import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonProps } from '@anytag/shared-atoms';
import { cn } from '@anytag/shared-utils';

export interface ActionButtonsProps {
  loading?: boolean;
  className?: string;
  children?: ReactNode;
  buttonHeight?: string;
  hasTopBorder?: boolean;
  primaryButtonProps?: ButtonProps;
  secondaryButtonProps?: ButtonProps;
}
export const ActionButtons = ({
  loading,
  children,
  className,
  hasTopBorder = false,
  buttonHeight = '24px',
  primaryButtonProps,
  secondaryButtonProps
}: ActionButtonsProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex items-center justify-end gap-2 p-4 text-size-input',
        hasTopBorder && 'border-t-border',
        className
      )}
    >
      {children}
      <Button
        variant="outline"
        title={t('Button.Cancel')}
        css={{ minWidth: '90px', height: buttonHeight }}
        {...secondaryButtonProps}
      />
      <Button
        variant="solid"
        title={t('Button.Apply')}
        loading={loading}
        css={{ minWidth: '90px', height: buttonHeight }}
        {...primaryButtonProps}
      />
    </div>
  );
};
